<template>
  <div>
    <div class="text">
      <span v-html="getSplitText(delimiter, 0)"></span>
      <span class="highlighted" v-html="highlitedText"></span>
      <span v-html="getSplitText(delimiter, 1)"></span>
    </div>
  </div>
</template>

<script>
import SplitTextMixin from './mixins/SplitTextMixin'

export default {
  name: 'GSLabelHighlight',
  mixins: [SplitTextMixin],
  props: {
    text: {
      type: String,
      required: true
    },
    highlitedText: {
      type: String,
      default: ''
    },
    delimiter: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/vars/base';

.text {
  color: #E0C390;
  text-align: center;
  font-size: $font-size;
  letter-spacing: 0;
  line-height: $base-size * 56;

  .highlighted {
    color: #31BEFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GSLabelHighlight.vue